import { useMemo } from 'react';
import MaintainMessageParser from './MaintainMessageParser';

export default function useParseMaintainMessage({ message }) {
  return useMemo(() => {
    return message && new MaintainMessageParser(message).parse();
  }, [message]);
}
